import { Component, Input } from '@angular/core';

import { GetInnerHtmlPipe } from '../../../pipe/get-inner-html/get-inner-html.pipe';
@Component({
  selector: 'app-post-text',
  templateUrl: './post-text.component.html',
  styleUrls: ['./post-text.component.scss'],
  imports: [GetInnerHtmlPipe],
})
export class PostTextComponent {
  @Input() postText: string | undefined;

  showMore = false;

  isOverflown(element: HTMLElement) {
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
  }
}
